import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { ToastContentHostDirective, ToastComponent } from './toast.component';
import { ToastService } from './toast.service';

@NgModule({
  imports: [CommonModule, TranslatePipe, ToastComponent, ToastContentHostDirective],
  bootstrap: [],
})
export class ToastModule {
  static forRoot(): ModuleWithProviders<ToastModule> {
    return {
      ngModule: ToastModule,
      providers: [ToastService, ToastContentHostDirective],
    };
  }
}
